// src/components/AGTFit/service/nutritionixService.js
import axios from 'axios';

// Obtener las credenciales desde las variables de entorno
const NUTRITIONIX_API_ID = process.env.REACT_APP_NUTRITIONIX_APP_ID;
const NUTRITIONIX_API_KEY = process.env.REACT_APP_NUTRITIONIX_API_KEY;

// Verificación de las credenciales
if (!NUTRITIONIX_API_ID || !NUTRITIONIX_API_KEY) {
  console.warn('Nutritionix API credentials are missing. Check your .env file.');
}

// Crear instancia de Axios con las cabeceras de autorización
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'x-app-id': NUTRITIONIX_API_ID,
    'x-app-key': NUTRITIONIX_API_KEY,
    'x-remote-user-id': '0' // 0 para desarrollo
  }
});

const nutritionixService = {
  // Buscar alimentos por texto
  searchFoods: async (query) => {
    try {
      
      const response = await apiClient.get(`https://trackapi.nutritionix.com/v2/search/instant?query=${encodeURIComponent(query)}`);
      
      return { 
        success: true, 
        data: [...(response.data.common || []), ...(response.data.branded || [])] 
      };
    } catch (error) {
      console.error('Error al buscar alimentos:', error);
      return { success: false, error: error.message };
    }
  },

  // Obtener detalles nutricionales de un alimento
  getFoodDetails: async (foodName, type = 'common') => {
    try {
      const endpoint = 'https://trackapi.nutritionix.com/v2/natural/nutrients';
      const payload = { query: foodName };
      
      const response = await apiClient.post(endpoint, payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error al obtener detalles de alimento:', error);
      return { success: false, error: error.message };
    }
  },

  // Escanear código de barras
  scanBarcode: async (barcode) => {
    try {
      const response = await apiClient.get(`https://trackapi.nutritionix.com/v2/search/item?upc=${barcode}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error al escanear código de barras:', error);
      return { success: false, error: error.message };
    }
  }
};

export default nutritionixService;